import { getClippedDirection } from '@app/utils/domHelpers'

function addLinkToAdjustment(
  span: HTMLSpanElement,
  link: string
): HTMLAnchorElement {
  const container = span.closest('#reconciliation-table-bloc') as HTMLElement

  // Check if the appearance of the button will cause the container to overflow
  const clippedDirection = container
    ? getClippedDirection(span, container, {
        top: 36,
        right: 150,
      })
    : {
        top: false,
        bottom: false,
        left: false,
        right: false,
      }

  const button = document.createElement('a')
  button.style.position = 'absolute'

  button.style.top = '-37px'

  if (clippedDirection?.right) {
    button.style.right = '0px'
  } else {
    button.style.left = '0px'
  }

  button.style.display = 'none'

  button.innerText = window.I18n.t('adjustment.title_new')
  button.classList.add('sf-btn')
  button.classList.add('tw-z-newAdjustment')
  button.href = link

  span.appendChild(button)

  return button
}

function changeElementDisplay(element: HTMLElement, display: string): void {
  window.requestAnimationFrame(() => {
    element.style.display = display
  })
}

function extractAccountEntryId(link: string): string {
  const queryString = link.split('?')[1]

  if (!queryString) {
    return ''
  }

  const urlParams = new URLSearchParams(queryString)

  return urlParams.get('account_entry_id') || ''
}

function wrapInSpan(linkElement: HTMLElement): HTMLSpanElement {
  const span = document.createElement('span')
  span.style.position = 'relative'

  const parent = linkElement.parentNode

  if (parent) {
    parent.replaceChild(span, linkElement)
    span.appendChild(linkElement)
  }

  return span
}

export default (): Array<() => void> => {
  const unsubscribers: Array<() => void> = []

  window.onDomLoad(function ($dom) {
    unsubscribers.forEach((unsubscriber) => unsubscriber())

    $dom.find("[data-behaviour='sf-new-adjustment-link']").each(function () {
      const span = wrapInSpan(this)
      const link = this.getAttribute('data-link') || ''

      const button = addLinkToAdjustment(span, link)

      function displayButtonBlock(): void {
        changeElementDisplay(button, 'block')
      }

      function displayButtonNone(): void {
        changeElementDisplay(button, 'none')
      }

      function handleButtonClick(e: Event): void {
        e.preventDefault()
        e.stopPropagation()

        const accountEntryId = extractAccountEntryId(link)

        window.modalCitizen.openModalPortal('adjustments-modal', {
          accountEntryId: accountEntryId
            ? parseInt(accountEntryId, 10)
            : undefined,
          mode: 'new',
        })
      }

      button.addEventListener('click', handleButtonClick)
      span.addEventListener('mouseover', displayButtonBlock)
      span.addEventListener('mouseout', displayButtonNone)

      unsubscribers.push(() => {
        button.removeEventListener('click', handleButtonClick)
        span.removeEventListener('mouseover', displayButtonBlock)
        span.removeEventListener('mouseout', displayButtonNone)
      })
    })
  })

  return unsubscribers
}
